// extracted by mini-css-extract-plugin
export default {"main":"PageNotFound_main__2P-QL","PageNotFound":"PageNotFound_PageNotFound__NNT8z","link":"PageNotFound_link__xtwZQ","icon":"PageNotFound_icon__F+RWM"};